import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import useSubmit from "../hooks/useSubmit";
import { useAlertContext } from "../context/alertContext";

const LandingSection = () => {
  const { isLoading, response, submit } = useSubmit();
  const { onOpen } = useAlertContext();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      email: "",
      type: "hireMe",
      comment: "",
    },
    onSubmit: (values) => submit("/api/contact", values),
    validationSchema: Yup.object({
      firstName: Yup.string().required("Required"),
      email: Yup.string().email("Invalid email address").required("Required"),
      type: Yup.string().required("Required"),
      comment: Yup.string().min(25, "Must be at least 25 characters").required("Required"),
    }),
  });

  useEffect(() => {
    if (!response) return;
    if (response.type === "success") {
      onOpen("success", response.message);
      formik.resetForm();
    } else if (response.type === "error") {
      onOpen("error", response.message);
    }
  }, [response]);

  return (
    <section className="bg-purple-900 text-white py-16 px-4 sm:px-8 md:px-16" id="contactme-section">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Contact Me</h1>
        <form onSubmit={formik.handleSubmit} className="bg-purple-800 p-6 md:p-10 rounded-lg shadow-lg">
          <div className="flex flex-col space-y-4">
            {/* Name */}
            <div>
              <label htmlFor="firstName" className="block mb-1 font-semibold">Name</label>
              <input
                id="firstName"
                name="firstName"
                type="text"
                {...formik.getFieldProps("firstName")}
                placeholder="First name"
                className={`w-full p-3 rounded-md text-black ${formik.touched.firstName && formik.errors.firstName ? "border-2 border-red-500" : ""}`}
              />
              {formik.touched.firstName && formik.errors.firstName ? (
                <p className="text-red-500 mt-1">{formik.errors.firstName}</p>
              ) : null}
            </div>

            {/* Email */}
            <div>
              <label htmlFor="email" className="block mb-1 font-semibold">Email Address</label>
              <input
                id="email"
                name="email"
                type="email"
                {...formik.getFieldProps("email")}
                placeholder="Email Address"
                className={`w-full p-3 rounded-md text-black ${formik.touched.email && formik.errors.email ? "border-2 border-red-500" : ""}`}
              />
              {formik.touched.email && formik.errors.email ? (
                <p className="text-red-500 mt-1">{formik.errors.email}</p>
              ) : null}
            </div>

            {/* Type */}
            <div>
              <label htmlFor="type" className="block mb-1 font-semibold">Type of enquiry</label>
              <select
                id="type"
                name="type"
                {...formik.getFieldProps("type")}
                className="w-full p-3 rounded-md text-black"
              >
                <option value="hireMe">Freelance project proposal</option>
                <option value="openSource">Open source consultancy session</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Comment */}
            <div>
              <label htmlFor="comment" className="block mb-1 font-semibold">Your message</label>
              <textarea
                id="comment"
                name="comment"
                {...formik.getFieldProps("comment")}
                placeholder="Message..."
                rows={6}
                className={`w-full p-3 rounded-md text-black ${formik.touched.comment && formik.errors.comment ? "border-2 border-red-500" : ""}`}
              />
              {formik.touched.comment && formik.errors.comment ? (
                <p className="text-red-500 mt-1">{formik.errors.comment}</p>
              ) : null}
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-purple-700 hover:bg-purple-600 transition-colors py-3 rounded-md font-semibold mt-2"
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default LandingSection;
